export default __webpack_public_path__ + "static/visionlaptop-40bb2169f915e4e649dafdc8ba12fcc1.png";